<template>
    <div>
        <section class="q10__jumbotron relative">
         
                <hotspot-richmedia
                    :options="{
                        icon: 'diaporama',
                        collection: getRichmediaByCollection(
                            currentPage,
                            'Dossier de presse : Kembs, un projet environnemental d’exception'
                        ),
                    }"
                    class="bottom-2 left-2 lg:left-36"
                />
                     
            <image-with-descriptions
                class="mb-8 mt-0"
                :options="{
                    image:
                        'pages/' +
                        currentPage.slug +
                        '/' +
                        currentPage.images.image1.src,
                    descriptions: [
                        {
                            text: currentPage.images.image1.alt,
                            position: 'bottom-left', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                        {
                            text: currentPage.images.image1.text,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                    ],
                }"
            />
            
        </section>
        <div class="page">
            <div class="container px-11 2xl:px-3 mb-14 m-auto">
                <title-s-chapter
                    :options="{
                        from: 'from-selective_orange',
                        to: 'to-selective_yellow',
                    }"
                >
                    <h1 v-html="currentPage.content.chapterTitle.text"></h1>
                </title-s-chapter>
                <p
                    class="font-bold text-tundora text-xl mb-5"
                    v-html="currentPage.content.chapterDescription.text"
                ></p>

                <div class="container-components">
                    <div class="card" style="margin-bottom: 0px;"> 
                        
                        <TitleParagraph
                            class="mb-4"
                            :options="{
                                from: 'from-selective_orange',
                                to: 'to-selective_yellow',
                            }"
                        >
                            <span
                                class="text-xl lg:text-2xl 2xl:text-4xl"
                                v-html="currentPage.content.firstTitle.text"
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="currentPage.content.firstParagraph.text"
                            >
                            </span>
                        </paragraph>
                        
                    </div>

                    <div class="block md:hidden">
                        <image-with-descriptions
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image4.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image4.text,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                        fontSize: 'text-xs md:text-base',
                                    },
                                ],
                            }"
                        />
                    </div>
                    <div class="card">
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.secondParagraph.text
                                "
                            >
                            </span>
                        </paragraph>
                        
                    </div>
                    <div class="card break-inside-avoid">
                        
                        <TitleParagraph
                            class="mb-4"
                            :options="{
                                from: 'from-selective_orange',
                                to: 'to-selective_yellow',
                            }"
                        >
                            <span
                                class="text-xl lg:text-2xl 2xl:text-4xl"
                                v-html="currentPage.content.secondTitle.text"
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="currentPage.content.thirdParagraph.text"
                            ></span>
                            <!-- <square
                                :options="{
                                    from: 'from-selective_orange',
                                    to: 'to-selective_yellow',
                                }"
                            /> -->
                        </paragraph>
                        
                    </div>
                </div>
                <div class="w-full md:w-3/4 mx-auto md:mt-10">
                    <image-with-descriptions
                        :options="{
                            image:
                                'pages/' +
                                currentPage.slug +
                                '/' +
                                currentPage.images.image2.src,
                            descriptions: [
                                {
                                    text: currentPage.images.image2.text,
                                    color: 'text-tundora',
                                    fontSize:
                                        'text-xs lg:m-0 text-xs lg:text-base xl:text-lg',
                                    position: 'top-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                                {
                                    text: currentPage.images.image2.alt,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                            ],
                        }"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
    },
    name : "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang="scss">
.txtMobil {
    margin: 0;
    font-size: 0.2rem !important;
    @media screen and(min-width: 768px) {
        font-size: 1.2rem !important;
    }
}
</style>
